import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { ARCADE_VARS } from '@/components/generals/arcade'
import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children, hideFooter = false }): ReactNode => {
    return (
        <div className='arc flex min-h-screen flex-col' style={ARCADE_VARS}>
            <a
                href='#main'
                className='sr-only z-[60] bg-[#ecca8c] px-3.5 py-2.5 text-xs uppercase text-[#574349] focus:not-sr-only focus:fixed focus:left-3 focus:top-2.5'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            {!hideFooter && <SiteFooter />}
        </div>
    )
}
